import { elementController } from '@public-pages/runtime-core';
import { useSmartScript } from '@public-pages/smartscript';

elementController('app-video', ({ query }) => {
  const { generateOneLinkQRCode, generateOneLinkURL } = useSmartScript();

  const storeDivElements = query('.app-video__stores');
  const storeLinksElements = storeDivElements?.getElementsByTagName('a');
  const qrCodeImgElement = query('.app-video__qrcode-img');

  if (storeLinksElements) {
    generateOneLinkURL('https://consumidorpositivo.onelink.me/3ote/pgvkj6v3', {
      af_sub3: JSON.stringify({
        type: 'link',
        path: location.pathname,
        location: 'section/app-video',
      }),
    }).then((clickURL) => {
      if (clickURL) {
        Array.from(storeLinksElements).forEach((link) => {
          link.href = clickURL;
        });
      }
    });
  }

  if (qrCodeImgElement) {
    generateOneLinkQRCode(
      'https://consumidorpositivo.onelink.me/3ote/pgvkj6v3',
      {
        af_sub3: JSON.stringify({
          type: 'qrcode',
          path: location.pathname,
          location: 'section/app-video',
        }),
      }
    ).then((base64) => {
      if (base64) qrCodeImgElement.setAttribute('src', base64);
    });
  }
});
